import { atom } from "recoil";
import { AtomKeys } from "../const/recoilKeys";

type MenuType = "status" | "itemList" | "ticketList" | "helpList" | "";

export const DisplayMenuState = atom<MenuType>({
  key: AtomKeys.DISPLAY_MENU_STATE,
  default: "",
});
